// extracted by mini-css-extract-plugin
module.exports = {"total":"ProductTotalPrice_total__E_t1M","empty":"ProductTotalPrice_empty__hOSt3"};